<template>
    <DFormRow
        :label="__('customers.customers.payment_term')"
        :error="errors.payment_term"
    >
        <div
            role="group"
            class="form-group"
        >
            <DSelect
                id="payment_term"
                :model-value="modelValue"
                :options="paymentTerms"
                :placeholder="__('customers.customers.select_payment_term')"
                @update:modelValue="emit('update:modelValue', $event)"
                @update:checked="paymentTermChanged"
            />
        </div>
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: [String, Number],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    paymentTerms: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['paymentTermChanged', 'update:modelValue'])

function paymentTermChanged (value) {
    emit('paymentTermChanged', value)
}
</script>
